import { useQuery } from 'urql';

export default useQuery;
